import ApartmentRounded from "@mui/icons-material/ApartmentRounded";
import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@bw/shared/api";
import { useAuth } from "@bw/shared/hooks";
import type { OrgWorkspaceContextResponse } from "@bw/shared/types/generated";
import { NavRow } from "../common/components/NavRow";
import { businessWorkspaceUrl } from "./businessWorkspaceUrl";

export function BusinessWorkspaceLink() {
  const { user } = useAuth();
  const href = businessWorkspaceUrl(window.location.hostname);
  const workspaces = useQuery({
    queryKey: ["player", "business-workspaces", user?.uid ?? null],
    queryFn: () =>
      httpClient.get<OrgWorkspaceContextResponse[]>("/orgs/me/options"),
    enabled: Boolean(user && href),
    retry: false,
    staleTime: 0,
    refetchOnMount: "always",
  });
  const current =
    workspaces.isSuccess &&
    workspaces.isFetchedAfterMount &&
    workspaces.fetchStatus === "idle" &&
    workspaces.error === null;
  if (!href || !current || workspaces.data.length === 0) return null;
  return <NavRow
    icon={<ApartmentRounded />}
    label="Business workspaces"
    value="Clubs you own or work with"
    href={href}
  />;
}
